import mainConfig from '../../../mainConfig';

export default new class Validation {
    constructor() {
        this.error = '.form__requirements';
        this.phoneInputClassName = 'js-phone';
        this.workingHoursInputClassName = 'js-workingHoursInput';
        this.phoneRegExp = /[+][0-9]{3}\s[0-9]{2}\s[0-9]{3}-[0-9]{2}-[0-9]{2}/;
        this.isDirtyAttrName = 'data-is-dirty',
        this.errroAnimateSpeed = 150;

        this.bindEvents();
    }

    /**
     * check does current form is valid
     *
     * @param $form - jQuery obj of form to validate
     * @returns {boolean} - is form valid
     */
    isFormValid($form) {
        let inputs = $form.find('input, textarea'),
            isFormValid = true,
            validateUntouched = true;

        $form.attr('novalidate', 'novalidate');

        for (let i = 0; i < inputs.length; i++) {
            if (!this.validateInput(inputs[i], validateUntouched)) {
                isFormValid = false;
            }
        }

        if (!isFormValid) {  //if form is invalid execute func to scroll up the viewport to the first error
            this.showTopError();
        }

        return isFormValid;
    }

    /**
     * scroll to the first input with error
     */
    showTopError () {
        let firstErrorMsg = document.querySelector(`.${mainConfig.errorMessages.inputErrorClassName}`);

        if (!firstErrorMsg) {
            return false;
        }

        let isVisible = this.checkVisible(firstErrorMsg),
            offsetFromTop = 25;

        if (!isVisible) {
            $('html, body').animate({
                scrollTop: $(firstErrorMsg).offset().top - offsetFromTop + 'px'
            }, 'slow');
        }
    }

    /**
     * checking, does elem visible on screen
     *
     * @param elm
     * @param threshold
     * @param mode
     * @returns {boolean}
     */
    checkVisible(elm, threshold, mode) {
        threshold = threshold || 0;
        mode = mode || 'visible';

        let rect = elm.getBoundingClientRect(),
            viewHeight = Math.max(document.documentElement.clientHeight, window.innerHeight),
            above = rect.bottom - threshold < 0,
            below = rect.top - viewHeight + threshold >= 0;

        return mode === 'above' ? above : (mode === 'below' ? below : !above && !below);
    }



    /**
     * add attr data-is-dirty=true
     *
     * @param $input - jQuery obj of input
     */
    setDirty($input) {
        if ($input.val().length) {
            $input.attr(this.isDirtyAttrName, true);
        }
    }

    /**
     * validate input, add/remove error classes, shows/hide error msgs
     *
     * @param input - input obj
     * @param validateUntouched - does func need to validate untouched input
     * @returns {boolean}
     */
    validateInput(input, validateUntouched = false) {
        let $input = $(input),
            isDisabled = !!$input.attr('disabled');

        if (isDisabled) {
            return true;
        }

        if (($input.attr(this.isDirtyAttrName) || validateUntouched)) {
            var isCurrentInputValid = input.checkValidity();

            if ($(input).hasClass(this.phoneInputClassName)) {
                isCurrentInputValid = this.validatePhoneNumberInput(input);
            }

            if ($(input).hasClass(this.workingHoursInputClassName)) {
                isCurrentInputValid = this.validateWorkingHoursInput(input);
            }

            if (!isCurrentInputValid) {
                $input.addClass(mainConfig.errorMessages.inputErrorClassName);
                this.showError($input);
            } else {
                $input.removeClass(mainConfig.errorMessages.inputErrorClassName);
                this.hideError($input);
            }

            return isCurrentInputValid;
        }
    }

    /**
     * shows error message
     *
     * @param $input - input obj
     */
    showError($input) {
        let $error = $input.siblings(this.error);

        $error.animate({
            height: 14
        }, this.errroAnimateSpeed, () => {
        });
    }

    /**
     * hides error message
     *
     * @param $input - input obj
     */
    hideError($input) {
        let $error = $input.siblings(this.error);

        $error.animate({
            height: 0
        }, this.errroAnimateSpeed, () => {
        });
    }

    /**
     * removes error class names from each input/textarea in current form
     *
     * @param $form - jQuerry form object
     */
    removeErrors($form) {
        let inputs = $form.find('input, textarea');

        for (let i = 0; i < inputs.length; i++) {
            $(inputs[i]).removeClass(mainConfig.errorMessages.inputErrorClassName);
        }
    }

    /**
     * test does current input val match phone regExp
     *
     * @param input - input obj
     * @returns {boolean} - does input valid
     */
    validatePhoneNumberInput(input) {
        let isCurrentInputValid = !!input.value.match(this.phoneRegExp);

        return isCurrentInputValid;
    }

    /**
     * test does current input val is correct time format
     *
     * @param input
     * @returns {boolean} - does input valid
     */
    validateWorkingHoursInput(input) {
        let firstCharOfStr = input.value.substring(0, 1),
            isCurrentInputValid = false;

        switch (firstCharOfStr) {
            case '0':
                isCurrentInputValid = input.value.match(/^[0][0-9]:[0-5][0-9]$/);
                break;

            case '1':
                isCurrentInputValid = input.value.match(/^[1][0-9]:[0-5][0-9]$/);
                break;

            case '2':
                isCurrentInputValid = input.value.match(/^[2][0-4]:[0-5][0-9]$/);
                break;
        }

        return isCurrentInputValid;
    }

    /**
     * add event listeners
     */
    bindEvents() {
        //check input validity on blur
        $(document)
            .on('change input cut copy paste', 'input[required]', (e) => {
                this.validateInput(e.target, true);
            })
            .on('blur', 'input[required], textarea[required]', (e) => {
                this.setDirty($(e.target));
                this.validateInput(e.target);
            });
    }
};

//:invalid:not(:focus):not(:placeholder-shown)


// WEBPACK FOOTER //
// ./src/common/assets/js/validation.js